/**
 * @prettier
 * @flow
 */
import * as React from 'react';
import { FormProvider } from 'react-hook-form';

export function Form({ form, onSubmit, style, className, children }: Props) {
    return (
        <FormProvider {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} style={style} className={className} noValidate>
                {children}
            </form>
        </FormProvider>
    );
}

type Props = {|
    form: any,
    onSubmit?: any,
    style?: any,
    className?: any,
    children?: any,
|};
